import { useTranslation } from "react-i18next"
import { useAuth } from '../auth/useAuth'
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { addDocument, editDocument, getDocument } from "../../actions/documentsActions"
import { useNavigate, useParams } from "react-router"
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap"
import Loader from "../loaders/Loader"
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Swal from "sweetalert2"


export default function DocumentsForm() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { id } = useParams()
    const isEditing = !!id

    const { document, resultdocument, loading } = useSelector(state => state.documents)
    const [editorState, setEditorState] = useState(EditorState.createEmpty())

    const [formState, setFormState] = useState({
        title: '',
        author: '',
        category: '',
        content: ''
    })

    useEffect(() => {
        if (clientauth && isEditing) {
            dispatch(getDocument(id))
        }
    }, [dispatch, clientauth, id])

    useEffect(() => {
        if (isEditing && document) {
            setFormState(document)

            if (document.content) {
                const blocksFromHtml = htmlToDraft(document.content)
                const { contentBlocks, entityMap } = blocksFromHtml
                const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap)
                setEditorState(EditorState.createWithContent(contentState))
            }
        }
    }, [document])

    useEffect(() => {
        if (resultdocument) {
            let resultnow = resultdocument
            dispatch({ type: 'DOCUMENT_RESET_RESULT' })
            switch (resultnow) {
                case 'documentCreated':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('manager.documents.createsuccess')
                    }).then(() => navigate('/admin/gestion_documental'))
                    break
                case 'documentUpdated':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('manager.documents.editsuccess')
                    }).then(() => navigate('/admin/gestion_documental'))
                    break
                default:
                    break
            }
        }
    }, [resultdocument, dispatch, t])

    const handleEditorStateChange = (editorState) => {
        setEditorState(editorState)

        setFormState({
            ...formState,
            content: draftToHtml(convertToRaw(editorState.getCurrentContent()))
        })
    }

    const handleInputChange = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (isEditing) {
            dispatch(editDocument(formState, id))
        } else {
            dispatch(addDocument(formState))
        }
    }

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col>
                    <h1>{isEditing ? t('manager.documents.editdocument') : t('manager.documents.createdocument')}</h1>
                </Col>
            </Row>
            {loading ? (
                <Loader />
            ) : (
                <Row className="justify-content-center">
                    <Col xs={12}>
                        <Card>
                            <Card.Body>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('manager.documents.title')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="title"
                                            value={formState.title}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('manager.documents.author')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="author"
                                            value={formState.author}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('manager.documents.category')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="category"
                                            value={formState.category}
                                            onChange={handleInputChange}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('manager.documents.content')}</Form.Label>
                                        <Editor
                                            wrapperClassName="border rounded"
                                            toolbarClassName="border-bottom mb-0"
                                            editorClassName="px-2"
                                            toolbar={{
                                                options: ['inline', 'list', 'textAlign', 'link'],
                                                inline: { options: ['bold', 'italic', 'underline'] },
                                                list: { options: ['unordered', 'ordered'] },
                                                textAlign: { options: ['left', 'center', 'right'] },
                                                link: { options: ['link', 'unlink'] }
                                            }}
                                            editorState={editorState}
                                            onEditorStateChange={handleEditorStateChange}
                                            editorStyle={{ minHeight: '400px' }}
                                        />
                                    </Form.Group>
                                    <div className="d-flex justify-content-end gap-2">
                                        <Button variant="secondary" onClick={() => navigate('/admin/gestion_documental')}>
                                            {t('manager.documents.cancel')}
                                        </Button>
                                        <Button variant="primary" type="submit">
                                            {isEditing ? t('manager.documents.save') : t('manager.documents.create')}
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}
        </Container>
    )
}